import { Grid } from "@mui/material";
import DatePickerField from "../../../../components/Dashboard/DatePickerField";
import { useIntl } from "../../../../contexts/IntlContext";

type Props = {
  startDate: string;
  endDate: string;
  onStartDateChange: (value: string) => void;
  onEndDateChange: (value: string) => void;
  disabled?: boolean;
  error?: string;
  /** YYYY-MM-DD; primeiro dia permitido para o início (dias anteriores ficam desabilitados). */
  minStartDate?: string;
};

/** Data de início/fim do período. `error` (quando informado) aparece como helperText do campo de fim. */
export default function PeriodRangeFields({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  disabled,
  error,
  minStartDate,
}: Props) {
  const intl = useIntl();
  return (
    <>
      <Grid item xs={12} md={6}>
        <DatePickerField
          label={intl.formatMessage({ id: "liveStreams.period.startDate" })}
          value={startDate}
          onChange={onStartDateChange}
          minDate={minStartDate}
          disabled={disabled}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <DatePickerField
          label={intl.formatMessage({ id: "liveStreams.period.endDate" })}
          value={endDate}
          onChange={onEndDateChange}
          minDate={startDate || minStartDate}
          disabled={disabled}
          error={Boolean(error)}
          helperText={error}
          fullWidth
        />
      </Grid>
    </>
  );
}
